import { type ComponentType, createContext, type PropsWithChildren, useContext } from 'react'
import type { TranslationFile } from '@omnea-app/packages/universal/i18n/translationFiles'

// 👇 Add translations for each resource type to the translation file
export type ResourceTypeStringKey = Extract<
  keyof TranslationFile<'common'>['organisation-switch-boundary']['resourceTypes'],
  string
>

export type OrganisationMismatchProps = {
  correctOrganisationId: string
  resourceType: ResourceTypeStringKey
}

// The org switch boundary needs the session, so the app injects it rather than this package depending on fe-auth.
const OrganisationMismatchContext = createContext<ComponentType<OrganisationMismatchProps> | null>(null)

export const OrganisationMismatchProvider = ({
  component,
  children,
}: PropsWithChildren<{ component: ComponentType<OrganisationMismatchProps> }>) => (
  <OrganisationMismatchContext.Provider value={component}>{children}</OrganisationMismatchContext.Provider>
)

export const useOrganisationMismatchComponent = () => useContext(OrganisationMismatchContext)
